import { ConApartados } from '../ConApartados';
import type { PropsPantalla } from '../tipos';
import { QuienRecibe } from './QuienRecibe';
import { TusAvisos } from './TusAvisos';
import './avisos.css';

/**
 * «Avisos» (Seguimiento, G128): la barra de apartados que manda el servidor, «Tus avisos» (`avisos_tus`, 5.1, la página
 * completa de la campana) y «Quién recibe avisos» (`avisos_quien`, 5.2, G294; solo con `entregas.avisos.configurar`).
 */
const APARTADOS = { avisos_tus: TusAvisos, avisos_quien: QuienRecibe };

export function Avisos(props: PropsPantalla) {
    return <ConApartados {...props} prefijo="avisos_" seccion="Avisos" icono="bell-ring" apartados={APARTADOS} cortas={{ avisos_quien: 'Quién recibe' }} />;
}
